<template>
  <div>
    <div class="component-image-upload">
      <FormUploadImage
        v-model="image"
        :placeholder="placeholder"
        :file-input-id="fileInputId"
        class="component-image-upload__image"
      />

      <div class="component-image-upload__controls">
        <div class="component-image-upload__texts">
          <div class="component-image-upload__texts__title">
            {{ title }}
            <span
              v-if="required"
              class="component-image-upload__texts__title__required"
              >*</span
            >
          </div>
          <p>{{ description }}</p>
        </div>
        <div class="component-image-upload__buttons">
          <label
            class="btn btn-sm btn-link component-image-upload__buttons__button"
            :for="fileInputId"
          >
            <i v-if="!image" class="icon-plus text-blue-900 fs13 pr-10"></i>
            <span v-if="image">Change</span>
            <span v-else>{{ selectButtonText }}</span>
          </label>

          <button
            v-if="image"
            class="component-image-upload__buttons__button btn btn-link btn-sm"
            @click="onRemove()"
          >
            Remove
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormUploadImage from '@/components/form/FormUploadImage/index'

export default {
  name: 'ImageUpload',
  components: {
    FormUploadImage
  },
  props: {
    title: {
      type: String,
      default: 'Upload image'
    },
    selectButtonText: {
      type: String,
      default: 'Select file'
    },
    placeholder: String,
    required: Boolean,
    description: {
      type: String
    },
    value: {
      type: Object
    },
    fileInputId: {
      type: String,
      default: 'file'
    }
  },
  data() {
    return {
      image: this.value
    }
  },
  watch: {
    image(newValue) {
      this.$emit('input', newValue)
    }
  },
  methods: {
    onRemove() {
      this.image = undefined
    }
  }
}
</script>

<style lang="scss">
.component-image-upload {
  display: flex;

  &__image {
    width: 140px;
    height: 140px;
    margin-right: 1.5rem;
  }

  &__controls {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  &__texts {
    &__title {
      &__required {
        color: $gray-900;
      }
    }

    p {
      padding-top: 4px;
      font-size: rem(14px);
      color: $gray-700;
      max-width: 320px;

      @include media-breakpoint-down(sm) {
        line-height: 1.5 !important;
        font-size: rem(13px);
      }
    }
  }

  &__buttons {
    display: flex;
    align-items: center;

    &__button {
      cursor: pointer;
      margin: 0 1rem 0 0;
    }
  }
}
</style>
